/**
 * Foundational SVG primitives shared by the cards subsystem.
 * Every card-* module that creates namespaced SVG elements imports from here.
 */

export const SVG_NS = "http://www.w3.org/2000/svg";

export function s(tag, attrs = {}) {
  const el = document.createElementNS(SVG_NS, tag);
  for (const [k, v] of Object.entries(attrs)) {
    el.setAttribute(k, String(v));
  }
  return el;
}
